export const EMPLOYEE_COMPLIANCE_READ = 'PEOPLE_MANAGEMENT_POLICY_CONSENT_READ_LIST';
export const EMPLOYEE_CREATE_POLICY_CONSENT = 'PEOPLE_MANAGEMENT_POLICY_CONSENT_CREATE';
export const EMPLOYEE_COMPLIANCE_REPORT_READ = 'PEOPLE_MANAGEMENT_POLICY_CONSENT_READ_REPORT_FE';

export const PORTAL_COMPLIANCE_REGISTRY_SEARCH_FILTER_SOURCE = 'specification:search';
export const PORTAL_COMPLIANCE_REGISTRY_ALL_ITEMS_PAGE_SIZE = 1000;
